import $, { extend } from 'jquery';
import React,{useEffect,useContext,useState} from 'react';
import { GlobalContext } from '../context';
import {CallMapMethod_CBack,getAppUrl} from '../function_lib/common_lib';
import Select from 'react-select';
import axios from 'axios';


export function CompItem_Auto_Complete_New(props){
  const {gbStPartyInfo, setPartyInfo, gbStItemInfo, setItemInfo} =useContext(GlobalContext);
  const [selectedOption, setSelectedOption] = useState(null);

  

  const handleChange = (option) => {
if(option!==null){
  if(typeof props.display_stock!=="undefined"){
    if(option.full_availability===null){
      option.full_availability=0;
    }
    document.getElementById(props.display_stock).value=option.full_availability+" -"+option.unit_name;
  }
  if(typeof props.display_stock_name!=="undefined"){
    document.getElementById(props.display_stock_name).innerHTML =option.label;
  }
}
    

    setSelectedOption(option);
  };

  const customStyles = {
    menu: (provided) => ({
      ...provided,
      //position: 'fixed',  // Change the position to static
      // height:'30px'
    }),
    // menuList: (provided) => ({
    //   ...provided,
    //   position: "fixed",  // Adjust padding if necessary
    // }),
    // input: (provided, state) => ({
    //   ...provided,
    //   height: '10px',
    // }),
    control: (provided, state) => ({
      ...provided,
      // height: '10px',
      width:'200px',
    }),
    // valueContainer: (provided, state) => ({
    //   ...provided,
    //   height: '30px',
    //   padding: '0 6px'
    // }),
  };

  useEffect(() => {
    //alert("i m in use effect "+props.defaultValue);
    if(typeof props.defaultValue!=="undefined" && props.defaultValue!==null){
      setSelectedOption({"value":atob(props.defaultValue),"label":props.defaultLabel});
    }else{
      setSelectedOption(null);
    }
      
    // This code will run after the component has mounted
//alert("hello"+gbStPartyInfo+"noon");   
const fetchData = async () => {
if((gbStPartyInfo===0 || gbStPartyInfo===null || gbStPartyInfo==="")|| props.setData===true){
var map=[];
//alert("i m in sync");
map.push({name:"curl_type",value:"getPartynItemsMaster"});
map.push({name:"res_func",value:"callBackrrr"});
map.push({name:"local_token",value:"000"});
map["res_func"]="callBackrrr";
map["curl_type"]="getPartynItemsMaster";
const apiUrl = getAppUrl()+"getPartynItemsMaster";
//alert(apiUrl);
const response = await axios.post(apiUrl, map);
var checkData=$($($.parseHTML(response.data)).filter("#resP")).text();
var checkMsg=$($($.parseHTML(response.data)).filter("#resPS")).text();
if(checkData!=="0"){
  let compMasterData=JSON.parse(checkData);
  //ExtCompAutoComplete(props,compMasterData["party_info"]);
  //alert(JSON.stringify(compMasterData["item_master"]));
  setPartyInfo(compMasterData["party_info"]);
  setItemInfo(compMasterData["item_master"]);
}
}else{
//ExtCompAutoComplete(props,gbStPartyInfo);
}


}
    
    fetchData();
    
    
    // You can return a cleanup function if needed
    return () => {
      // This code will run when the component unmounts
      //console.log('Component unmounted');
    };
  }, [props.autoList,props.defaultValue]); // Pass an empty array as the second argument to run the effect only once after mounting
if(props.setData!==true){
  return(<><Select 
   className="my-select-item"
   styles={customStyles}
     id={props.comp_id}
     name={props.comp_name}
    target_obj={props.target_obj}
    value={selectedOption}
    onChange={handleChange}
    options={gbStItemInfo}
    getOptionLabel={(option) => option.label}
    getOptionValue={(option) => btoa(option.value)}
    placeholder={props.placeHolder}
    isClearable
  />
  <input {...(props.required_mg !== undefined ? { required_mg: props.required_mg } : {})} className={props.propClassHid} type="hidden" name={props.target_obj} id={props.target_obj} 
  defaultValue={selectedOption ? btoa(selectedOption.value) : ''}
/>
{typeof  props.comp_sel_text!=="undefined"?<input  required_mg={props.required_mg}  className={props.propClass} type="hidden" name={props.comp_sel_text} id={props.comp_sel_text}
defaultValue={selectedOption?selectedOption.label:''}
 />:''}
  </>)
}else{
  return(<></>);
}

}


export function CompStudent_Auto_Complete_New(props){
    const [selectedOption, setSelectedOption] = useState(null);
    const handleChange = (option) => {
      setSelectedOption(option);
      
      if(option !==null){
        props.compOnChange(btoa(option.id));
      }
      
      //alert(JSON.stringify(option));
      //onChange(option);
    };
    useEffect(()=>{
        setSelectedOption(null);
    },[props.studentList])
    
return(<><Select className={props.propClass}
    //inputId={props.target_obj}
     id={props.comp_id}
     name={props.comp_name}
    target_obj={props.target_obj}
    value={selectedOption}
    onChange={handleChange}
    options={props.studentList}
    getOptionLabel={(option) => option.student_name+" / "+option.father_name}
    getOptionValue={(option) => btoa(option.id)}
    placeholder={props.placeHolder}
    isClearable
  />
  <input type="hidden" name={props.target_obj} id={props.target_obj} 
  value={selectedOption ? btoa(selectedOption.id) : ''}
  />
  </>)
}
export default CompStudent_Auto_Complete_New;